
const toZhwyview = r => require.ensure([], () => r(require('@/page/toZhwy/toZhwyview')), 'toZhwyview');
const toZhwy = r => require.ensure([], () => r(require('@/page/toZhwy/toZhwy')), 'toZhwy');

const toZhwyRouter = {
  path: '',
  redirect: '/toZhwy',
  name: '招标投标管理',
  component: toZhwyview,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
  },
  children: [
    { path: '/toZhwy', component: toZhwy, name: '招标投标管理', meta: { right: [], isShowMenu: true, keepAlive: true }, },
  ]
};
export default toZhwyRouter;
